<template>
  <li :class="[isActive ? 'active' : 'finished']" >
    <span class="stepSpan"  v-bind:style="stepSpanStyle">{{ step }}</span>
    <span class="d-block pt-2">
      <slot></slot>
    </span>
    <span v-if="currentIndexStep >= step" class="checkSpan" v-bind:style="checkSpanStyle">
      <i class="icon-check"></i>
    </span>
  </li>
</template>

<script>
export default {
  props: {
    step: Number,
    currentIndexStep: Number
  },
  computed: {
    MainUISettings() {
      return this.$store.getters["GET_MAIN_UI"];
    },
    isInactive(){
      return (this.currentIndexStep != (this.step - 1))
    },
    isActive(){
      return (this.currentIndexStep == (this.step - 1))
    },
    isCompleted(){
      return this.currentIndexStep >= this.step;
    },
    stepSpanStyle() {
      var btnBackgroundColor = this.$store.getters["GET_MAIN_UI"].button_color;

      return this.isActive ?  {
        "border": "1px solid " + btnBackgroundColor,
        "background-color": "#FFFFFF",
        "color": btnBackgroundColor,
      } : null;
    },
    checkSpanStyle() {
      var btnTextColor = this.$store.getters["GET_MAIN_UI"].button_text_color;
      var btnBackgroundColor = this.$store.getters["GET_MAIN_UI"].button_color;

      return this.isCompleted ? {
        "button-color": btnTextColor,
        "background-color": btnBackgroundColor,
      } : null;
    },
  }
};
</script>

<style lang="scss" scoped>

// .stepSpan { 
//   border-color: var(--border);
//   // background-color: white;

// }
// .checkSpan { 
//   background-color: var(--button-background-color)
// }

// .active {
//   color: var(--button-color);
//   background-color: var(--button-background-color);
// }


</style>